/**
 * 날짜별 개인 일정 쿼리 키 팩토리.
 *
 * `attendances` 루트 밖에 둔다 — `correctionKeys` 와 같은 사유다. 일정은 출퇴근·정정과
 * 별도 테이블·별도 엔드포인트이고, 출퇴근 뮤테이션(출근·퇴근·정정 승인)이 일정 목록을 지울
 * 이유가 없다. 반대로 일정 뮤테이션은 **달력 점**을 갱신해야 하므로 월 목록도 함께 무효화한다.
 *
 * 월 축과 일 축이 따로 있는 것은 소비처가 둘이기 때문이다 — 셀의 점은 월 단위로 한 번 받고,
 * 서랍은 그 날짜만 받는다. 하나로 합치면 서랍을 열 때마다 월 전체를 다시 받는다.
 */
import { defineInvalidation, defineQueryKeys } from '@/shared/lib/queryKeys';

const keys = defineQueryKeys('attendance-day-schedules', (all) => ({
  /** 무효화 전용 접두사 — 조회에 쓰지 않는다. */
  allPrefix: [...all] as const,

  /** 그 달 전체 (달력 점). */
  month: (month: string | undefined) => [...all, 'month', month] as const,
  /** 그 날 목록 (서랍). */
  date: (date: string | undefined) => [...all, 'date', date] as const,
}));

/**
 * 무효화 계약.
 *
 * 축이 하나뿐인 것은 의도다 — 일정 한 건이 바뀌면 그 날 목록과 그 달의 점이 **동시에** 바뀐다.
 * 둘을 갈라 선언하면 호출부가 매번 둘 다 적어야 하고, 하나를 빠뜨리면 점이 조용히 stale 된다.
 */
export const {
  keys: dayScheduleKeys,
  root: dayScheduleRoot,
  invalidate: invalidateDayScheduleScopes,
} = defineInvalidation(keys, {
  all: keys.allPrefix,
});
